/** GZ chart geometry under contract mas.gz-report.v1: one polyline per contiguous OK run (never joined across a gap);
 * non-OK angles returned separately as markers; a missing value is never plotted (no zero, no interpolation). */
export interface GzPoint { heel_deg: number; GZ_m: number | null; status?: string; reason?: string | null }
export function gzRuns(points: GzPoint[]) {
  const sorted = [...points].sort((a, b) => a.heel_deg - b.heel_deg);
  const runs: GzPoint[][] = []; let cur: GzPoint[] = [];
  const ok = (p: GzPoint) => (p.status ?? 'OK') === 'OK' && typeof p.GZ_m === 'number' && Number.isFinite(p.GZ_m);
  for (const p of sorted) { if (ok(p)) cur.push(p); else { if (cur.length) runs.push(cur); cur = []; } }
  if (cur.length) runs.push(cur);
  return { runs, markers: sorted.filter((p) => !ok(p)) };
}
